import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { createReducer } from "@reduxjs/toolkit";
import { defaultSourceIdValues, LinkRestrictionState } from "../actions/LinkRestriction/types";
import {
    getLinkRestriction,
    linkRestrictionReceived,
    receivedSourceIds,
    toggleRight1Panel,
    toggleSegmentInfoExpanded
} from "actions";

const initialState: LinkRestrictionState = {
    isRightSideBar1Open: false,
    isLinkRestrictionFetched: false,
    linkRestrictionData: null,
    isSegmentInfoExpanded: false,
    sourceIds: defaultSourceIdValues
};

export const linkRestriction = createReducer(initialState, (builder) => {
    builder
        .addCase(getLinkRestriction, (state) => {
            state.isLinkRestrictionFetched = false;
        })
        .addCase(linkRestrictionReceived, (state, action) => {
            state.linkRestrictionData = action.payload.data;
            state.isLinkRestrictionFetched = true;
        })
        .addCase(toggleRight1Panel, (state, action) => {
            state.isRightSideBar1Open = action.payload.isOpen;
        })
        .addCase(receivedSourceIds, (state, action) => {
            state.sourceIds = action.payload.sourceIds;
        })
        .addCase(toggleSegmentInfoExpanded, (state, action) => {
            state.isSegmentInfoExpanded = action.payload.isSegmentInfoExpanded;
        })
        .addCase(resetStateRTK, (state) => {
            state = initialState;
        })
        .addDefaultCase((state) => state);
});

export default linkRestriction;
